export default __webpack_public_path__ + "static/orangeloop-analisi-dati-come-prendere-decisioni-aziendali-strategiche-27c52314412e50b1e8bfb96d6f1a04dd.jpg";